// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"354":"882160b8","540":"42a200f5","792":"115aeec5","984":"9fb8dfb9"}[chunkId] + ".css";
};